import { FETCH_ENVIRONMENTS } from '../actions/types';

const initialState = [];

function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ENVIRONMENTS:
      return action.payload;
    default:
      return state;
  }
}
export default reducer;
